export const getInitialLanguage = () => {
    const languages = { EN: 'EN', RU: 'RU', BG: 'BG'}
    let language = ''
    try {
        // Try get from store
        language = localStorage.getItem('language')
        if (!language) {
            // Try get from browser
            language = (
                (navigator.languages && navigator.languages[0]) ||
                navigator.language ||
                navigator.userLanguage ||
                ''
            )
                .split('-')[0]
                .toUpperCase()
        }
    } catch (e) {}
    // Return only existing languages
    return languages[language] || ''
}



// WEBPACK FOOTER //
// ./src/Modules/language/index.js